module.exports = __webpack_public_path__ + "img/gluten_free-off.b8ca9799.svg";